import React, { useEffect } from 'react';
import { ArrowRight, BarChart3, MessageCircle, WandSparkles } from 'lucide-react';
import markLogo from 'src/assets/branding/auto-appy-mark-256x256.png';
import { useAuth } from 'src/context/AuthContext';

const SAMPLE = process.env.REACT_APP_DEV_LOGIN === 'true';

/** Signed-out screen. Production goes straight to Auto Appy sign-in. */
export default function SignInPage({ onSignIn, offline }) {
  const { signInSample } = useAuth();
  useEffect(() => {
    if (!SAMPLE && !offline) onSignIn();
  }, [offline, onSignIn]);

  return (
    <div className="mx-boot mx-signin">
      <img src={markLogo} alt="" />
      <strong>Auto Appy Meta Ads</strong>
      <span>Create Facebook and Instagram ads in minutes, see what they bring in, and let rules look after them.</span>
      <ul className="mx-signin-points">
        <li><MessageCircle size={16} aria-hidden="true" />Get WhatsApp chats, calls and leads</li>
        <li><BarChart3 size={16} aria-hidden="true" />Results and costs in plain words</li>
        <li><WandSparkles size={16} aria-hidden="true" />Rules that pause, grow and alert</li>
      </ul>
      {offline && <span className="mx-signin-warn">Auto Appy cannot be reached right now. Check your connection and try again.</span>}
      <button type="button" className="ws-btn ws-btn--primary ws-btn--lg" onClick={onSignIn}>Sign in with Auto Appy <ArrowRight size={16} aria-hidden="true" /></button>
      {SAMPLE && (
        <div className="mx-signin-sample">
          <span>Local development</span>
          <button type="button" className="ws-btn ws-btn--quiet" onClick={() => signInSample('owner')}>Sample owner</button>
          <button type="button" className="ws-btn ws-btn--quiet" onClick={() => signInSample('member')}>Sample member</button>
        </div>
      )}
    </div>
  );
}
